import { FC } from 'react'
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
} from '@microservices/wiskey-react-table-component'

type CustomToolbarComponentProps = {
  showColumnsButton: boolean
}

export const CustomToolbarComponent: FC<CustomToolbarComponentProps> = ({ showColumnsButton }) => {
  return (
    <GridToolbarContainer>
      {showColumnsButton ? <GridToolbarColumnsButton /> : <></>}
    </GridToolbarContainer>
  )
}
